import * as NUMBERS from 'constant/number'
import * as ROUTES from 'constant/routes'
import { SettingOutlined, QuestionCircleOutlined, LogoutOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logout } from 'action/auth'
import { Menu, Dropdown, Avatar } from 'antd'
import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import styles from './index.scss'

// eslint-disable-next-line max-lines-per-function
/* eslint-disable complexity */
const UserAvatar = ({ user, logout }) => {
  return (
    <Dropdown
      className={'d-block'}
      overlay={(
        <Menu>
          <Menu.Item
            className={styles.logout_link}
            icon={<LogoutOutlined />}
            label='Logout'
            onClick={logout}
          >
                      Logout
          </Menu.Item>
        </Menu>
      )}
      placement={'bottomRight'}
      trigger={['click']}
    >
      <Avatar
        className={classnames(styles.username, 'align-content-center')}
        shape='square'
        size='large'
      >
        {user ? `${user.first_name[NUMBERS.ZERO].toUpperCase()}${user.last_name[NUMBERS.ZERO].toUpperCase()}` : 'U'}
      </Avatar>
    </Dropdown>
  )
}

UserAvatar.propTypes = {
  logout: PropTypes.func,
  user: PropTypes.object
}

const mapStateToProps = (state) => {
}

const mapDispatchToProps = (dispatch) => ({
  logout: bindActionCreators(logout, dispatch)
})

export default connect(undefined, mapDispatchToProps)(UserAvatar)
